<template>
    <div class="ranking-query-index">
        <dzTab :active.sync="activeTab" :tabs="tabs" :name="$options.name" use-route />
        <slot name="notice" :activeTab="activeTab"></slot>
        <router-view v-bind="$attrs" :checkVersion="checkVersion" />
    </div>
</template>
<script>
import dzTab from '@packages/components/dzTab';

export default {
    name: 'RankingQuery',
    components: {
        dzTab,
    },

    props: {
        videoCourseUrl: {
            type: String,
            default: 'http://newhelp.fjdaze.com/help_dz/show-31.html',
        },
        courseUrl: {
            type: String,
            default: 'http://newhelp.fjdaze.com/help_dz/show-42.html',
        },
        isLimit: {
            type: Boolean,
            default: false,
        },
        renewalUrl: {
            type: String,
            default:
                'https://pc.1688.com/product/detail.htm?spm=a260s.11177607.jcrmedqi.11.3ba9646bv9SLqr&productCode=hatpDR%2BVFLes1QB3WvP432DTXr2x9KS%2B49fbzLAYPF4%3D&productType=GROUP&f=xufei',
        },
    },
    data() {
        return {
            activeTab: 'shopRankingQuery',
            tabs: [
                {
                    name: '全店产品排名查询',
                    tab: 'shopRankingQuery',
                },
                {
                    name: '单产品排名查询',
                    tab: 'productionRankingQuery',
                },
                {
                    name: '关键词排名查询',
                    tab: 'keywordsRankingQuery',
                },
                {
                    name: '排名查询记录',
                    tab: 'queryRecord',
                },
            ],
        };
    },

    mounted() {
        if (this.videoCourseUrl) {
            this.tabs.push({
                name: '视频教程',
                tab: this.videoCourseUrl,
                icon: 'iconfont-npm icon-npm-gantan orangeFont',
            });
        }
        if (this.courseUrl) {
            this.tabs.push({
                name: '图文教程',
                tab: this.courseUrl,
                icon: 'iconfont-npm icon-npm-gantan orangeFont',
            });
        }
    },

    methods: {
        checkVersion() {
            let isLimit = false;
            if (this.isLimit) {
                isLimit = true;
                this.$confirm('该功能为付费功能，升级后可使用', '提示', {
                    confirmButtonText: '立即升级',
                    type: 'warning',
                    dangerouslyUseHTMLString: true,
                    showCancelButton: false,
                })
                    .then(() => {
                        window.open(this.renewalUrl);
                    })
                    .catch(() => {});
            }
            return isLimit;
        },
    },
};
</script>
<style lang="scss" scoped>
.ranking-query-index {
    min-width: 1200px;
}
</style>
